import { useState } from 'react';
import { Subcategory } from '../../../interfaces/Article.interface';
import './SubcategoryBox.scss';

// @ts-ignore
import iconChevronR from '../../../assets/icons/CDA/icon_chevron-right.svg';
import { Link } from 'gatsby';

interface Props {
    subcategory: Subcategory,
    color: string
}

const SubcategoryBox = ({ subcategory, color }: Props) => {

    const [mouseHover, setMouseHover] = useState<boolean>(false);

    return (
        <Link
            to={subcategory.slug}
            className={`a-subcategories-box gtmExplorarporcategoriassubcategorias${subcategory.name.replace(/ /g, '')}Home`}
            onMouseEnter={() => setMouseHover(true)}
            onMouseLeave={() => setMouseHover(false)}
        >
            <div
                className={`line gtmExplorarporcategoriassubcategorias${subcategory.name.replace(/ /g, '')}Home`}
                style={{ backgroundColor: color }}></div>
            <h3
                style={{ color: mouseHover ? color : 'var(--color-blackred__white)' }}
                className={`gtmExplorarporcategoriassubcategorias${subcategory.name.replace(/ /g, '')}Home`}
            >
                {subcategory.name}
            </h3>
            {/* <p>Aquí va una descripción si en un futuro se habilita.</p> */}
            <i className={`icon-icon_chevron-right-1 gtmExplorarporcategoriassubcategorias${subcategory.name.replace(/ /g, '')}Home`}
                style={{ color: mouseHover ? color : '#303030', filter: mouseHover ? 'none' : 'var(--filter-none-brightness)' }}></i>
        </Link>
    )
}

export default SubcategoryBox